/**
 * This class is responsible for holding segments of a path
 * e.g. { rootPath: "/contracts", param: "123" }
 */
export class PathSegment {
  constructor(public rootPath: string, public param?: string) {}
}
